'use client';

import { Plus } from '@byway/icons';
import clsx from 'clsx';
import { useLocale, useTranslations } from 'next-intl';
import { Heading } from 'ui';
import { TripCardSkeletons } from '~/components/Account/AccountSkeletons';
import ReferralCard from '~/components/Account/ReferralCard';
import { SavedTripCard } from '~/components/AccountTripCards/AccountTripCards';
import { getDefaultBuildSearch } from '~/constants/default-origin';
import { Link } from '~/i18n/navigation';
import { api } from '~/libs/api';

const CREATE_TRIP_PATHNAME = '/map/build';

export default function SavedTrips() {
  const { data: savedTrips, isLoading } = api.account.savedTrips.useQuery();
  const locale = useLocale();
  const t = useTranslations('account');

  return (
    <div>
      <Heading as="h2" variant="h4">
        {t('saved_journeys_heading')}
      </Heading>
      <div className="grid grid-cols-1 gap-4 mt-4 lg:grid-cols-4">
        <div className="md:col-span-2 lg:col-span-3">
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {isLoading ? (
              <TripCardSkeletons />
            ) : (
              <>
                {(savedTrips ?? []).map((trip) => (
                  <SavedTripCard variant="saved" key={trip.tripId} tripId={trip.tripId} />
                ))}
                <div
                  className={clsx({
                    'md:col-span-3': !savedTrips?.length,
                    'md:col-span-2': savedTrips?.length === 1
                  })}
                >
                  <Link href={`${CREATE_TRIP_PATHNAME}${getDefaultBuildSearch(locale)}`}>
                    <div className="flex flex-col items-center justify-center w-full h-48 px-4 py-8 border rounded-lg bg-neutral-100 md:h-full">
                      <Plus decorative size="large" strokeWidth={3} />
                      <p className="text-center">
                        {savedTrips?.length ? t('create_another_journey') : t('create_first_journey')}
                      </p>
                    </div>
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
        <div>
          <ReferralCard />
        </div>
      </div>
    </div>
  );
}
